export default "__VITE_ASSET__yY_7rXSP__"